import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

interface ReturnsType {
  replace(path: string, shallow?: boolean): void,
}

const useRouterReplace = (): ReturnsType => {
  const location = useLocation()

  const trackRouting = (page: string) => {
    ReactGA.send({ hitType: 'pageview', page })
  }

  const replace = (path: string) => {
    trackRouting(path)
    window.history.replaceState(location.state, '', path)
  }

  return { replace }
}

export default useRouterReplace
